module.exports = __webpack_public_path__ + "img/p1-pic.78c34536.jpg";